import clsx from "clsx";
import getPlayerContent from "@/domains/chat/helpers/getPlayerContent";
import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";

export default function ChatSceneMessage({ message, settings }: MessageProps) {
  const { showTime } = settings;

  return (
    <div className={clsx("w-full text-[#e66dec]")}>
      {showTime && <Time date={message.date} />} <span>{message.message.content}</span>{" "}
      <span>({getPlayerContent(message)})</span>{" "}
    </div>
  );
}
